import { hasAnySim, isStatusValid } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { ConsultaSeguimentoPergunta06Model } from './model-consultaSeguimentoPergunta06'
import { isPergunta06PegarAllNao } from './utils-consultaSeguimentoPergunta06'

export const validatorConsultaSeguimentoPergunta06 = createValidator<ConsultaSeguimentoPergunta06Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_06_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta06Model, errors: ErrorObject<ConsultaSeguimentoPergunta06Model>) => {
    if (values?.PERGUNTA_06_HEADER === SimNaoEnum.NAO) {
      if (hasAnySim(values?.PERGUNTA_06_PEGAR)) {
        errors.PERGUNTA_06_APONTAR_PARA = required(values?.PERGUNTA_06_APONTAR_PARA)
      } else if (!isPergunta06PegarAllNao(values?.PERGUNTA_06_PEGAR)) {
        errors.PERGUNTA_06_PEGAR = 'Deve responder sim para algum ou não para todos'
      }
    }
    return errors
  }
)
